import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type RatePriceAdjustmentId = Branded<string, "RatePriceAdjustmentId">;
const ratePriceAdjustmentIdPrefix = "rate_price_adjustment__";
const {
    factory: ratePriceAdjustmentIdFactory,
    assert: isRatePriceAdjustmentId,
    zodSchema: ratePriceAdjustmentIdZodSchema,
} = genericId<RatePriceAdjustmentId>(ratePriceAdjustmentIdPrefix);

export {
    isRatePriceAdjustmentId,
    ratePriceAdjustmentIdFactory,
    ratePriceAdjustmentIdPrefix,
    ratePriceAdjustmentIdZodSchema,
};
export type { RatePriceAdjustmentId };
